__turbopack_context__.v({
  "body": "bP7a8G_body",
  "close": "bP7a8G_close",
  "header": "bP7a8G_header",
  "login-panel-in": "bP7a8G_login-panel-in",
  "overlay": "bP7a8G_overlay",
  "panel": "bP7a8G_panel",
  "root": "bP7a8G_root",
});
